import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { BROWSE_FLIGHTS_SEARCH } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { browseFlightsSearch: bffResponse };
}

export default function useBrowseFlightsSearch(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(BROWSE_FLIGHTS_SEARCH, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables } = {}) =>
      restRequest({
        method: 'POST',
        path: '/air-api/v1/flights/browse-search',
        body: variables,
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
